@if (formGroup) {
<div class="flex place-content-between">
  <h1 mat-dialog-title>Create issue</h1>
  <div class="p-2">
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
      <mat-icon class="material-symbols-rounded">close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content data-cy="create-issue-modal" class="mat-typography">
  <form [formGroup]="formGroup">
    <div class="flex flex-col items-center">
      <mat-form-field class="w-full max-w-2xl px-2">
        <mat-label class="font-medium text-gray-900">Module</mat-label>
        <mat-select formControlName="module" required>
          @for (module of sortedModules; track module.id) {
          <mat-option value="{{ module.id }}">{{ module.name }}</mat-option>
          }
        </mat-select>
        @if(moduleDropdownControl?.hasError('required')){
        <mat-error>Module not selected</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-full max-w-2xl px-2">
        <mat-label class="font-medium text-gray-900">Issue Type</mat-label>
        <mat-select formControlName="issueType" required>
          @for (issueType of sortedIssueTypeData(); track issueType.id) {
          <mat-option value="{{ issueType.id }}">{{
            issueType.name
          }}</mat-option>
          }
        </mat-select>
        @if(issueTypeDropdownControl?.hasError('required')){
        <mat-error>Issue Type not selected</mat-error>
        }
      </mat-form-field>
      @if(issueTypeId()) {
      <mat-tab-group
        mat-align-tabs="center"
        class="w-full min-h-full create-issue-tabs"
      >
        <mat-tab label="Create">
          <gcp-workspace-render-issue-type
            [issueTypeIdInput]="issueTypeId()"
            [moduleId]="moduleId()"
            [formMode]="FormMode.CREATE_ISSUE"
            [issuesCreated]="issuesCreated"
            (issuesCreatedChange)="onIssuesCreatedChange($event)"
            class="w-full min-h-full"
          ></gcp-workspace-render-issue-type>
        </mat-tab>
        <mat-tab label="Import">
          <gcp-workspace-import-issues
            class="w-full min-h-full"
            [issueTypeId]="issueTypeId()"
          ></gcp-workspace-import-issues>
        </mat-tab>
      </mat-tab-group>

      } @else {
      <div class="empty-state">
        <mat-icon class="material-symbols-rounded empty-state-icon"
          >assignment_add</mat-icon
        >
        <h2 class="empty-state-title">Create a new issue</h2>
        <p class="empty-state-text">
          Pick a <span class="font-medium">Module</span> and an
          <span class="font-medium">Issue Type</span> above to load its form, then
          fill in the details. Once an issue type is selected you can also use the
          <span class="font-medium">Import</span> tab to bulk-create issues from a
          spreadsheet.
        </p>
      </div>
      }
    </div>
  </form>
</mat-dialog-content>
}
